import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import ListLayout from 'components/ListLayout';
import { RootState } from 'app/store';
import PaymentMethodForm from 'components/PaymentMethodLayout';
import { AllowPaymentMethods, Merchant } from 'types/Merchant';
import Loader from 'components/Loader';
import { handleError, handleSuccess } from 'utils';
import { UPDATE_MESSAGE } from 'const/Message';
import { getMerchantV2 } from 'services/merchantService';
import { updatePaymentMethodV2 } from 'services/paymentMethodService';

const PaymentMethod = () => {
  const [mode, setMode] = useState<'list' | 'edit'>('list');
  const { merchantSlug } = useSelector((state: RootState) => state.user);
  const queryClient = useQueryClient();
  const { data: dataMerchant } = useQuery<
    Merchant & { onlinePayment: boolean }
  >('getMerchant', ({ signal }) => getMerchantV2(merchantSlug, signal));

  const handleSave = (dataSave: AllowPaymentMethods[]) => {
    if (dataMerchant?.onlinePayment) {
      dataSave.push('by_card');
    } else {
      dataSave.push('by_cash'); // set default by_cash for not yet enabled for online payment merchants
    }

    const allowPayment: Pick<Merchant, 'allowPaymentMethods'> = {
      allowPaymentMethods: dataSave
    };
    updatePaymentMethodMutate(
      { slug: merchantSlug, data: allowPayment },
      {
        onSuccess: () => {
          queryClient.invalidateQueries('getMerchant');
          setMode('list');
          handleSuccess(UPDATE_MESSAGE.UPDATE_PAYMENT_METHOD_SUCCESS);
        },
        onError: (error: any) => {
          handleError(
            error.response.status,
            UPDATE_MESSAGE.UPDATE_PAYMENT_METHOD_ERROR
          );
        }
      }
    );
  };

  const { isLoading: isLoadingUpdate, mutate: updatePaymentMethodMutate } =
    useMutation(
      ({
        slug,
        data
      }: Required<{
        slug: string;
        data: { allowPaymentMethods: AllowPaymentMethods[] };
      }>) => updatePaymentMethodV2(slug, data)
    );

  return (
    <ListLayout>
      {dataMerchant && (
        <PaymentMethodForm
          mode={mode}
          onChangeMode={(m: 'list' | 'edit') => setMode(m)}
          allowPaymentMethod={dataMerchant.allowPaymentMethods}
          isCardPaymentAllowed={dataMerchant.onlinePayment}
          onSave={handleSave}
        />
      )}
      {isLoadingUpdate && <Loader />}
    </ListLayout>
  );
};

export default PaymentMethod;
